const normalizeEnvironmentName = (value) => {
    if (typeof value !== 'string') {
        return '';
    }

    return value.trim().toLowerCase();
};

export const getRuntimeEnvironmentName = () => {
    if (typeof window !== 'undefined') {
        const runtimeEnvironment = normalizeEnvironmentName(window.__APP_ENVIRONMENT__);
        if (runtimeEnvironment) {
            return runtimeEnvironment;
        }
    }

    return normalizeEnvironmentName(process.env.NODE_ENV);
};

export const isProductionRuntime = () => getRuntimeEnvironmentName() === 'production';
